<template>
  <f7-page id="calendar-page" name="calendar" @page:beforeremove="onPageBeforeRemove"
           @page:init="onPageInit"
           @page:reinit="debug('reinit')"
           @page:beforein="debug('beforein')"
           @page:afterout="debug('afterout')"
           @page:beforeunmount="debug('beforeunmount')"
  >
    <f7-navbar back-link="" no-shadow>
      <f7-nav-title>
        Training inplannen <f7-icon f7="question_circle" @click="showHelp = true"></f7-icon>
      </f7-nav-title>
      <f7-nav-right>
        <f7-link icon-only>
          <!--          <f7-icon f7="person_circle_fill">-->
          <f7-badge color="primary">
            <strong>
              {{ parseFloat($store.getters['current_user/credits']) }}x
            </strong>
          </f7-badge>
          <!--          </f7-icon>-->
        </f7-link>
        <f7-icon f7="gear_alt" @click="showCalendarSettings = true"></f7-icon>
      </f7-nav-right>
    </f7-navbar>
    <f7-actions id="actions-two-groups" v-model:opened="openPowerRacksList" v-if="selectedTrainingSlot" @touchmove.stop>
      <f7-actions-group>
        <div class="safe-area-top"></div>
        <div class="safe-area-top"></div>
        <img src="/gym-layout-01.png" alt="gym image" style="width: 100%;"/>
        <f7-actions-label>
          Kies je eiland
        </f7-actions-label>
        <f7-actions-button @click="reserveTrainingSlotFinalStep(null)">
          Geen voorkeur
        </f7-actions-button>
        <f7-actions-button v-for="powerRack in sortedAvailableRacksList(selectedTrainingSlot.available_racks_list)"
          @click="reserveTrainingSlotFinalStep(powerRack)"
        >
          {{ powerRack.name }}
        </f7-actions-button>
      </f7-actions-group>
      <f7-actions-group style="position: sticky; bottom: 0;">
        <f7-actions-button color="red">Cancel</f7-actions-button>
      </f7-actions-group>
    </f7-actions>
    <f7-toolbar position="top">
      <f7-link @click="goToPreviousMonth" class="navbar-calendar-previous-month"></f7-link>
      <f7-nav-title class="navbar-calendar-title"></f7-nav-title>
      <f7-link @click="goToNextMonth" class="navbar-calendar-next-month"></f7-link>
    </f7-toolbar>
    <div id="calendar" class="block block-strong no-padding no-margin"></div>
    <f7-list id="calendar-events" class="no-margin no-safe-area-left list-strong list-dividers">
      <f7-list-item v-for="(item, index) in eventItems"
                    :data-training-slot="JSON.stringify(item.training_slot)"
                    :key="index"
                    :title="item.title"
                    :after="item.time"
                    v-bind:class="{'full': item.full}"
      >
        <div class="event-color" :style="{'background-color': item.color}" slot="root-start"></div>
      </f7-list-item>
      <f7-list-item v-if="eventItems.length === 0">
        <span class="text-color-gray" slot="title"></span>
      </f7-list-item>
    </f7-list>

    <calendar-settings-sheet-modal
        :show="showCalendarSettings"
        @closed="showCalendarSettings = false"
    >
    </calendar-settings-sheet-modal>
    <calendar-help-sheet-modal
        :show="showHelp"
        @closed="showHelp = false"
    >
    </calendar-help-sheet-modal>

    <!-- PREF-05 / IC4. Opened from the booking-success path below and from
         nowhere else -- never on mount, never at app launch. This page holds the
         boolean; the sheet only reports that it has gone away. -->
    <notification-permission-sheet
        :show="showNotificationPermissionSheet"
        @closed="showNotificationPermissionSheet = false"
    >
    </notification-permission-sheet>
  </f7-page>
</template>
<script>

import {f7, f7ready, f7Navbar, f7Page, f7NavTitle, f7List, f7ListItem} from 'framework7-vue';
import moment from 'moment';
import utility from "../../js/utility";
import CalendarSettingsSheetModal from "../../components/calendar/CalendarSettingsSheetModal.vue";
import dom7 from 'dom7';
import CalendarHelpSheetModal from "@/components/calendar/CalendarHelpSheetModal.vue";
import NotificationPermissionSheet from "../../components/general/NotificationPermissionSheet.vue";

export default {
  components: {
    CalendarHelpSheetModal,
    f7Navbar,
    f7Page,
    f7NavTitle,
    f7List,
    f7ListItem,
    CalendarSettingsSheetModal,
    NotificationPermissionSheet,
  },
  data() {
    const date = new Date();
    return {
      eventItems: [],
      page: null,
      preloader: null,
      showCalendarSettings: false,
      showHelp: false,
      selectedTrainingSlot: null,
      openPowerRacksList: false,
      // PREF-05. Owned here, flipped in exactly one place
      // (offerNotificationPermission) and reset by the sheet's `closed` event.
      showNotificationPermissionSheet: false,
    };
  },
  mounted() {
    setTimeout(() => {
      if(this.$store.getters['current_user/missing_naw'] && !this.$store.getters['current_user/hasBeenRedirected']) {
        this.$store.dispatch('current_user/hasBeenRedirected', {});
        f7.views.main.router.navigate('/users/' + this.current_user.id);
      }
    }, 500);

    this.showHelp = this.currentUser.show_calendar_help;
  },
  computed: {
    currentUser() {
      return this.$store.getters['current_user/data'];
    },
    selectedDate() {
      if (typeof this.calendar === 'undefined') {
        return moment().format(this.dateFormat);
      }
      let date = this.calendar.getValue();
      date = new Date(date);
      let day = date.getDate().toString().padStart(2, '0');
      let month = (date.getMonth() + 1).toString().padStart(2, '0');
      let year = date.getFullYear();

      return year + '-' + month + '-' + day;
    },
    dateFormat() {
      return this.$store.getters['app/date_format'];
    },
    availableSlots() {
      return this.$store.getters['training_slots/available_slots'];
    },
    availableEvents() {
      let availableEvents = [];
      this.availableSlots.forEach(availableSlot => {
        availableSlot = utility.clone(availableSlot);
        let date = moment(availableSlot.date, this.dateFormat);
        // This is needed to adhere to the F7 calendar formatting
        availableSlot.formatted_date = availableSlot.date;
        availableSlot.date = new Date(date.year(), date.month(), date.date());
        availableSlot.title = new Date(date.year(), date.month(), date.date());
        availableEvents.push(availableSlot);
      });
      return availableEvents;
    },
    duration() {
      return this.$store.state.training_slots.duration;
    },
    interval() {
      return this.$store.state.training_slots.interval;
    },
  },
  created() {
    // We show a preloader so the navigation won't feel janky
    this.$store.commit('app/show_loader');
    this.fetchGyms();
  },
  methods: {
    debug(name) {
      // console.info('calendar debug(): ' + name);
      // const self = this;
      // console.log(self.calendar);
    },
    renderEvents(calendar) {
      const self = this;

      // We need to use the Calendar here or it won't have the latest values.
      const currentDate = this.convertCalendarValueToDate(calendar);

      let currentEvents = self.availableEvents.filter(event => {
        return event.formatted_date === currentDate.format(self.dateFormat);
      });

      const eventItems = [];
      if (currentEvents.length) {
        currentEvents.forEach((training_slot) => {
          const hours = training_slot.hours;
          let minutes = training_slot.minutes;
          if (minutes < 10) minutes = `0${minutes}`;
          eventItems.push({
            title: '(' + training_slot.occupied_racks_count + '/' + training_slot.available_racks + ') - ' + training_slot.description,
            time: `${hours}:${minutes}`,
            color: training_slot.color,
            full: training_slot.full || training_slot.reserved_by_self,
            training_slot: training_slot,
          });
        });
      }
      self.eventItems = eventItems;
    },
    onPageInit(page) {
      this.page = page;
      setTimeout(() => {
        this.createCalendar(page);
      }, 500)
    },

    createCalendar(page) {
      const self = this;
      const app = f7;
      const $ = dom7;
      let vm = this;

      let weeksAhead = 1;
      if (this.$store.state.current_user.data.is_admin) {
        weeksAhead = 4;
      }

      self.calendar = app.calendar.create({
        containerEl: '#calendar',
        toolbar: false,
        value: [moment().format(this.dateFormat)],
        events: self.availableEvents,
        locale: 'NL-nl',
        minDate: moment().startOf('day'), // Can't book before now, obviously
        maxDate: moment().add(weeksAhead, 'weeks'), // Can't book more than 4 weeks ahead, for now
        on: {
          init(calendar) {
            // Er zit een bug in met dubbele calenders, die halen we er hier even uit
            // _nu_ al tijd voor een refactor
            let calendars = calendar.$containerEl.find('#calendar .calendar');
            if(calendars.length > 1) {
              calendars[0].remove();
            }

            vm.updateHeaders(calendar, $);
            app.navbar.size(app.navbar.getElByPage(page.el));
            calendar.$el.addClass('no-safe-area-right');

            // Get the data we need.
            self.fetchTrainingSlots(calendar).then(response => {
              self.$store.commit('app/hide_loader');
              self.removeClickEvents(calendar, $);
              self.renderEvents(calendar);
              self.addClickEvents(calendar, $);
            });
          },
          monthYearChangeStart(calendar) {
            vm.updateHeaders(calendar, $);
            app.navbar.size(app.navbar.getElByPage(page.el));

            // Update the data we need.
            self.$store.commit('app/show_loader');
            self.fetchTrainingSlots(calendar).then(response => {
              self.$store.commit('app/hide_loader');
            });
          },
          // Triggered when a user clicks on a day, or if the calendar value changes
          // dynamically
          change(calendar) {
            self.removeClickEvents(calendar, $);
            self.renderEvents(calendar);
            self.$nextTick(() => {
              self.addClickEvents(calendar, $);
            })
          },
        },
      });
    },
    destroyCalendar() {
      const self = this;
      self.calendar.destroy();
      // this.page hier ook de DOM clearen?
    },
    onPageBeforeRemove() {
      this.destroyCalendar();
    },
    updateHeaders(calendar, $) {
      const monthNames = ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'];

      $('.navbar-calendar-title').text(`${monthNames[calendar.currentMonth]}, ${calendar.currentYear}`);
      $('.navbar-calendar-previous-month').text(`${monthNames[(calendar.currentMonth + 11) % 12]}`);
      $('.navbar-calendar-next-month').text(`${monthNames[(calendar.currentMonth + 1) % 12]}`);
    },
    goToNextMonth() {
      this.calendar.nextMonth();
    },
    goToPreviousMonth() {
      this.calendar.prevMonth();
    },
    addClickEvents(calendar, $$) {
      $$('#calendar-events .item-content').on('click', (event) => {
        this.reserveTrainingSlot(calendar, event)
      });
    },
    removeClickEvents(calendar, $$) {
      $$('#calendar-events .item-content').off('click');
    },
    reserveTrainingSlot(calendar, event) {
      let vm = this;

      if(event.currentTarget.parentElement.className.includes('full')) {
        // Hier kan in de toekomst een popup voor het annuleren van de reservering
        return;
      }

      vm.selectedTrainingSlot = JSON.parse(event.currentTarget.parentElement.dataset.trainingSlot);
      setTimeout(() => {
        // Needed to prevent some weird Action Stack Dialog render issue
        vm.openPowerRacksList = true;
      }, 1)
    },
    reserveTrainingSlotFinalStep(powerRack) {
      let vm = this;
      let time = (this.selectedTrainingSlot.hours + "").padStart(2, '0') + ':' + (this.selectedTrainingSlot.minutes + "").padStart(2, '0');

      let timeslot = moment(this.selectedTrainingSlot.date).format('YYYY-MM-DD') + ' ' + time;

      if(!powerRack) {
        // When no preference, we randomly select
        let powerRacks = this.selectedTrainingSlot.available_racks_list;
        powerRack = powerRacks[Math.floor((Math.random()*powerRacks.length))];
      }
      let powerRackText = 'eiland ' + powerRack.name;

      // ----------------------------------------------------------------------
      // PREF-05 / IC4 bookkeeping for the confirmation dialog below.
      //
      // The explainer sheet may only open once TWO things have happened: the
      // booking resolved successfully, and this dialog finished closing. Which
      // of the two lands last is genuinely unpredictable -- tapping `Bevestig`
      // starts the dialog's close animation immediately while the request is
      // still in flight, so the request normally wins, but a warm connection on
      // a slow animation reverses it. Opening a sheet into a modal that is still
      // animating out is the exact render defect this file already carries two
      // setTimeout workarounds for (see reserveTrainingSlot and onPageInit), so
      // both orderings are handled and whichever completes last runs the offer.
      //
      // `dialog.opened` is deliberately NOT used as the signal: Framework7 sets
      // it to false when the close STARTS (modal-class.js onClose), so it reads
      // as closed while the dialog is still on screen. The `closed` event fires
      // when the animation has actually ended (onClosed).
      // ----------------------------------------------------------------------
      let bookingSucceeded = false;
      let dialogHasClosed = false;
      let afterDialogClosed = null;

      const dialog = f7.dialog.create({
        content: '<div class="dialog-title">' + this.selectedTrainingSlot.description + '<br/>' + timeslot + '</div><div id="reserve-training-slot">Je staat op het punt ' + powerRackText + ' voor ' + (this.selectedTrainingSlot.duration / 60) + ' uur te boeken.</div>',
        on: {
          closed: () => {
            dialogHasClosed = true;

            if (afterDialogClosed) {
              const run = afterDialogClosed;
              afterDialogClosed = null;
              run();
            }
          },
        },
        buttons: [
          {
            text: 'Annuleer',
            color: 'red',
            close: true,
          }, {
            text: 'Bevestig',
            bold: true,
            onClick: () => {
              vm.$store.commit('app/show_loader');
              vm.$store.dispatch('training_slots/store', {
                gym_id: this.selectedTrainingSlot.gym.id,
                power_rack_id: powerRack ? powerRack.id : null,
                date: this.selectedTrainingSlot.formatted_date,
                time: time,
                duration: this.selectedTrainingSlot.duration,
              }).then((response) => {
                // console.log('then dialog')
                bookingSucceeded = true;

                vm.fetchTrainingSlots(vm.calendar);

                vm.$store.dispatch('current_user/fetch', {});

              }).finally(() => {
                // console.log('finally dialog')
                vm.$store.commit('app/hide_loader');

                // Success only. `.finally()` runs on rejection too, and a member
                // whose booking just failed must not be asked to turn on
                // reminders for it -- hence the flag set in `.then()` rather
                // than a bare `.finally()`.
                if (!bookingSucceeded) {
                  return;
                }

                if (dialogHasClosed) {
                  vm.offerNotificationPermission();
                } else {
                  afterDialogClosed = () => vm.offerNotificationPermission();
                }
              }).catch(() => {
                // A failed booking is already reported to the member: the api
                // module's global error handler raises a danger toast for every
                // rejected request, which is why nothing is shown here.
                //
                // The catch itself is not decoration. Without it the rejection
                // escaped this chain unhandled on every failed booking -- silent
                // in a browser, an "Unhandled Rejection" in the test runner, and
                // on a device a promise nobody owns. Found by the failed-booking
                // case in tests/components/general/NotificationPermissionSheet.test.js.
              });
            }
          }
        ],
      });

      dialog.open();
    },

    /**
     * PREF-05 / IC4: offer the notification explainer after a first booking.
     *
     * Reached only from the booking-success path above. Never on mount, never at
     * app launch -- asking at launch is the fastest way to a permanent denial,
     * because iOS gives the app exactly one prompt and a member who has not yet
     * seen a reason to say yes says no.
     *
     * This opens the in-app EXPLAINER, not the OS prompt. The only thing that
     * can reach the OS is a member tapping `Notificaties aanzetten` inside the
     * sheet; declining it leaves iOS's one shot unspent and the notifications
     * settings screen keeps offering it.
     */
    async offerNotificationPermission() {
      let vm = this;

      try {
        // Decide against the LIVE OS state rather than a cached one: the member
        // may have granted or revoked permission in the phone's settings app
        // since this value was last read, and an explainer for a permission that
        // is already settled leads to a button that can do nothing.
        await vm.$store.dispatch('push/refresh_permission');
      } catch (e) {
        // A plugin that is missing or throwing is not the member's problem, and
        // it must not surface as an unhandled rejection on the booking path. The
        // getter below then decides on whatever the store already holds, which
        // for an unreadable permission is not 'prompt' -- so nothing opens.
      }

      // One getter rather than three inlined conditions -- push supported,
      // permission still 'prompt', and this device not asked before. They live
      // in the store precisely because three inlined conditions drift: a caller
      // remembering two of them re-asks a member who already declined.
      if (!vm.$store.getters['push/should_offer_permission_prompt']) {
        return false;
      }

      // Marked on OPEN, not on accept. A member who declined HAS been asked, and
      // re-showing the explainer after every booking is both nagging and
      // self-defeating: it ends up dismissed reflexively, which is how the one
      // shot gets spent by accident.
      vm.$store.dispatch('push/mark_permission_prompt_shown');

      setTimeout(() => {
        // Needed to prevent some weird Action Stack Dialog render issue
        vm.showNotificationPermissionSheet = true;
      }, 1);

      return true;
    },
    fetchTrainingSlots(calendar) {
      return this.$store.dispatch('training_slots/availability', {
        from: this.firstDayOfCalendar(calendar),
        to: this.lastDayOfCalendar(calendar),
        gym_ids: [this.currentUser.gym.id], // This should be dynamic in the future
        interval: 30,
        duration: this.duration,
      }).then(data => {
        // console.log('fetchTrainingSlots', data);
      })
    },
    fetchGyms() {
      return this.$store.dispatch('gyms/fetch_all');
    },
    convertCalendarValueToDate(calendar) {
      return moment(calendar.getValue()[0]);
    },
    convertCalendarValueToFormattedDate(calendar) {
      return this.convertCalendarValueToDate(calendar).format(this.dateFormat);
    },
    firstDayOfCalendar(calendar) {
      // We subtract 7 days here because the calendar shows the previous month as well
      return moment(calendar.currentYear + '-' + (calendar.currentMonth + 1).toString().padStart(2, '0') + '-01', this.dateFormat).subtract(7, 'days').format(this.dateFormat);
    },
    lastDayOfCalendar(calendar) {
      // We add 14 days here because the calendar shows the next month as well
      return moment(calendar.currentYear + '-' + (calendar.currentMonth + 1).toString().padStart(2, '0') + '-01', this.dateFormat).endOf('month').add(14, 'days').format(this.dateFormat);
    },
    sortedAvailableRacksList(availableRacks) {
        return utility.sortObjectByKey(availableRacks, 'name');
    }
  },
  watch: {
    availableEvents(value) {
      if (typeof this.calendar !== 'undefined') {
        this.calendar.params.events = value;
        this.calendar.update();
      }
    },
    availableSlots: {
      deep: true,
      handler(value) {
        if (typeof this.calendar !== 'undefined') {
          this.removeClickEvents(this.calendar, dom7);
          this.renderEvents(this.calendar);
          this.addClickEvents(this.calendar, dom7);
        }
      }
    },
    duration() {
      this.fetchTrainingSlots(this.calendar);
    },
    interval() {
      this.fetchTrainingSlots(this.calendar);
    },
  }
};

</script>

<style lang="scss">
  #calendar-page {
    .item-content {
      padding-left: 0;
    }
    .list .item-inner {
      padding-left: 20px;
    }
  }
  .safe-area-top {
    height: env(safe-area-inset-top);
    width: 100%;
  }
</style>
